const ROOMS = {
    room1: {
      id: 'room1',
      name: 'Fertitta Hall (JFF)',
      shortName: 'JFF',
      imagePath: '/images/JFF.png'
    },
    room2: {
      id: 'room2',
      name: 'Popovich Hall F2 and F3 (JKP)',
      shortName: 'JKP',
      imagePath: '/images/jkp-merged.png'
    }
  };

  export const getRoomName = (roomId) => ROOMS[roomId]?.name || 'Select Building';
  export const getRoomShortName = (roomId) => ROOMS[roomId]?.shortName;
  export const getRoomImagePath = (roomId) => ROOMS[roomId]?.imagePath;
  export const getRooms = () => Object.values(ROOMS);
  export const ROOM_IDS = Object.keys(ROOMS);
  
  export default ROOMS;
  